const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`65b0b25a5dbbf7a9e641f13c3afeeecfdc10b490200ed7d0728103a1d05fd1b4`, `65b0b25a5dbbf7a9e641f13c3afeeecfdc10b490200ed7d0728103a1d05fd1b4`, 1, 66), undefined, true, false, 1));
            }

            getTemplateName() {
                return `65b0b25a5dbbf7a9e641f13c3afeeecfdc10b490200ed7d0728103a1d05fd1b4`;
            }

            getSourceContext() {
                return new this.Source(``, `65b0b25a5dbbf7a9e641f13c3afeeecfdc10b490200ed7d0728103a1d05fd1b4`, ``);
            }
        }],
        [66, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/embed/embed.twig`, `65b0b25a5dbbf7a9e641f13c3afeeecfdc10b490200ed7d0728103a1d05fd1b4`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/embed/embed.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <img src="`);
                this.echo(this.env.getFilter('escape').traceableCallable(3, this.source)(...[this.env, (context.has(`src`) ? context.get(`src`) : null), `html`, null, true]));
                this.echo(`" alt="">
  `);
            }

            getTemplateName() {
                return `65b0b25a5dbbf7a9e641f13c3afeeecfdc10b490200ed7d0728103a1d05fd1b4`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `65b0b25a5dbbf7a9e641f13c3afeeecfdc10b490200ed7d0728103a1d05fd1b4`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '65b0b25a5dbbf7a9e641f13c3afeeecfdc10b490200ed7d0728103a1d05fd1b4');

let template = env.loadTemplate('65b0b25a5dbbf7a9e641f13c3afeeecfdc10b490200ed7d0728103a1d05fd1b4');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/embed/demo/image.twig", args: context }
     );
     return rendered;;
};